import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { CommonBaseURl } from "./Commonprovider/CommonProvider";

const PrivateRoute = () => {
    const [BaseURL] = useState(CommonBaseURl);
    const token = useSelector((state) => state.Authenticationapi.token);

    // Session Check API
    // const checkSession = async () => {
    //     try {
    //         const UserId = localStorage.getItem("getuserid");
    //         const sessionToken = localStorage.getItem("session_token");

    //         if (!UserId || !sessionToken) return;

    //         const response = await fetch(`${BaseURL}GetSessionToken`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json; charset=UTF-8",
    //             },
    //             body: JSON.stringify({ UserID: UserId }),
    //         });

    //         const data = await response.json();

    //         if (data?.session_token && data.session_token !== sessionToken) {
    //             handleLogout("You have been logged out because your account was accessed from another device.");
    //         }
    //     } catch (err) {
    //         console.error("Session check failed:", err);
    //     }
    // };

      const checkSession = async () => {
        try {
            const UserId = sessionStorage.getItem('getuserid');
            const sessionToken = sessionStorage.getItem('session_token');

            // If either value is missing, don't proceed
            if (!UserId || !sessionToken) return;

            const response = await fetch(`${BaseURL}GetSessionToken`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                },
                body: JSON.stringify({ UserID: UserId }),
            });

            const data = await response.json();

            if (data && data.session_token) {
                if (data.session_token !== sessionToken) {
                    localStorage.clear();
                    sessionStorage.clear();
                    alert("You have been logged out because your account was accessed from another device.");
                    window.location.href = "/";
                }
            }
        } catch (err) {
            console.error("Session check failed:", err);
            // localStorage.clear();
            // sessionStorage.clear();
            // alert(err);
            // window.location.href = "/";
        }
    };

    // Common Logout Handler
    const handleLogout = (message) => {
        localStorage.clear();
        sessionStorage.clear();
        if (message) alert(message);
        window.location.href = "/";
    };

    // API polling (every 30 sec)
     useEffect(() => {
        checkSession(); // initial check

        const interval = setInterval(() => {
            checkSession();
        }, 30000);

        return () => clearInterval(interval);
    }, []);

     useEffect(() => {
        // Only run once the document is fully loaded
        if (document.readyState === "complete") {
            checkSession();
        } else {
            window.addEventListener("load", checkSession);
            return () => window.removeEventListener("load", checkSession);
        }

        const interval = setInterval(checkSession, 30000); // every 30 seconds

        return () => clearInterval(interval);
    }, []);
  
    // Cross-tab logout listener
    // useEffect(() => {
    //     const handleStorageChange = (event) => {
    //         if (
    //             event.key === "session_token" ||
    //             event.key === "getuserid" ||
    //             event.key === null // triggered on clear()
    //         ) {
    //             const sessionToken = localStorage.getItem("session_token");

    //             if (!sessionToken) {
    //                 window.location.href = "/";
    //             }
    //         }
    //     };

    //     window.addEventListener("storage", handleStorageChange);

    //     return () => {
    //         window.removeEventListener("storage", handleStorageChange);
    //     };
    // }, []);

    // Route protection
    return token?.access_token ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;